import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { MaterialSummary } from "../../schemas";
import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

export function Total(props: { data: MaterialSummary[], colors: { [key: string]: string } }) {

  const ref = useRef<Pie & SVGElement>(null);
  const [outerRadius, setOuterRadius] = useState<string | number>("50%");

  const data = props.data.reduce((dict, item) => {
    if (!(item.material_id in dict)) {
      dict[item.material_id] = 0
    }
    dict[item.material_id] += item.count
    return dict
  }, {} as { [key: string]: number });

  const materials = props.data.reduce((dict, item) => {
    dict[item.material_id] = item.material_name;
    return dict
  }, {} as { [key: string]: string })

  const dataList = Object.entries(data).map(([id, count]) => ({ id: id as string | 0, count }))
  dataList.sort((a, b) => b.count - a.count)

  const sum = dataList.reduce((sum, item) => sum + item.count, 0)
  const iOthers = dataList.findIndex(item => item.count / sum < 0.1)

  var reducedDataList = dataList;
  if (iOthers > 0 && iOthers < dataList.length - 1) {
    reducedDataList = dataList.slice(0, Math.max(iOthers, 2));

    reducedDataList.push({ id: 0, count: dataList.slice(iOthers).reduce((sum, item) => sum + item.count, 0) })
  }

  const r = ref.current?.props.outerRadius;

  useEffect(() => {
    if (r && typeof (r) === 'number' && r > 100) setOuterRadius(100);
  }, [r])

  return (
    <ResponsiveContainer>
      <PieChart>
        <Pie
          ref={ref}
          data={reducedDataList}
          nameKey="id"
          dataKey="count"
          startAngle={90}
          endAngle={-270}
          cy={(typeof (r) === 'number' && r + 50) || '50%'}
          outerRadius={outerRadius}
          label={({ name, percent, value, x, y, fill, cx, index }) => {
            let textAnchor = x > cx ? 'start' : 'end';
            if (index === reducedDataList.length - 1 && value < sum * 0.1 && reducedDataList[0].count > sum * 0.2) {
              textAnchor = 'start'
            }
            return (
              <g>
                <text x={x} y={y - 10} fill={fill} textAnchor={textAnchor}>
                  {name}
                </text>
                <text x={x} y={y + 10} fill={fill} textAnchor={textAnchor}>
                  {`${value} (${(percent * 100).toFixed(1)}%)`}
                </text>
              </g>
            )
          }}
        >
          {reducedDataList.map((d, i) =>
            <Cell key={i} fill={props.colors[d.id] || '#808080'} name={materials[d.id] || (d.id === 0 && 'Others') || ''} />)}
        </Pie>
        <Tooltip content={
          ({ payload }) => {
            const data = payload?.[0]?.payload;
            if (!data) return null;
            const { count, name, fill } = data;
            const percent = (count / sum * 100).toFixed(1);
            return (
              <Box style={{ backgroundColor: 'white', fontSize: 'small', padding: 4, border: '1px solid grey' }}>
                <div style={{ color: fill }}>{name}</div>
                <div style={{ color: fill }}>{count} ({percent} %)</div>
              </Box>
            )
          }
        } />
      </PieChart>
    </ResponsiveContainer>
  )
}
